import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useRef,
  useContext,
} from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  createStyles,
} from "@material-ui/core";

import {
  CpfInput,
  CnpjInput,
  DialogoConfirmacao,
  AutoCompleteLocal,
  AutoCompleteRemoto,
} from "../../../../../components";
import {
  ATALHO_VOLTAR,
  ATALHO_AVANCAR,
  SECONDARY_COLOR,
  SECONDARY_COLOR_OFFLINE,
  validarCNPJ,
  validarCPF,
  formatCPF,
  formatCNPJ,
  PRIMARY_COLOR,
  STATUS_ATIVO,
  formatMoeda,
} from "../../../../../utils";
import InputBase from "@material-ui/core/InputBase";
import { useSnackbar } from "notistack";
import { getListAllAPI } from "../../../../../services";

import { AppContext } from "../../../../../app/context";

const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const ESC_ACTION = "Escape";
const CONSULTOR_PRECOS_ACTION = "F3";
const NOVO_CLIENTE_ACTION = "F9";
const EDITAR_CLIENTE_ACTION = "F7";

const useStyles = makeStyles((theme) =>
  createStyles({
    action: {
      display: "flex",
      justifyContent: "space-between",
    },
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    button: {
      color: "white",
      backgroundColor: theme.palette.secondary.main,
    },
    disabledButton: {
      backgroundColor: "red",
    },
  })
);

const TELA_INCLUIR_DOCUMENTO = 2;
const TELA_TIPO_DOCUMENTO = 3;
const TELA_CPF = 4;
const TELA_CNPJ = 5;

function TelaOpcao({
  value,
  onChange,
  erro,
  options,
  handleEnter,
  handleKey,
  label,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AutoCompleteLocal
        handleEnter={() => handleEnter()}
        label={""}
        handleKey={handleKey}
        value={value}
        onChangeLocal={(value) => {
          onChange(value);
        }}
        error={erro !== ""}
        helperText={erro}
        campo="nome"
        options={options}
        variant="standard"
        autoFocus
      />
    </div>
  );
}

function TelaCpf({ value, onChange, erro, handleEnter, handleKey }) {
  return (
    <div>
      <CpfInput
        name="cpf"
        handleEnter={() => {
          if (erro === "") {
            handleEnter();
          }
        }}
        label="CPF"
        handleKey={handleKey}
        value={value}
        onChange={(value) => onChange(value.target.value)}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoCompleteState="new-password"
        autoFocus
      />
    </div>
  );
}

function TelaCnpj({ value, onChange, erro, handleEnter, handleKey }) {
  return (
    <div>
      <CnpjInput
        name="cnpj"
        handleEnter={() => {
          if (erro === "") {
            handleEnter();
          }
        }}
        label="CNPJ"
        handleKey={handleKey}
        value={value}
        onChange={(value) => onChange(value.target.value)}
        error={erro !== ""}
        helperText={erro}
        fullWidth
        autoCompleteState="new-password"
        autoFocus
      />
    </div>
  );
}

const TIPO_DOCUMENTO_CPF = "cpf";
const TIPO_DOCUMENTO_CNPJ = "cnpj";

const optionsTipoDocumento = [
  {
    id: TIPO_DOCUMENTO_CPF,
    nome: "CPF",
  },
  {
    id: TIPO_DOCUMENTO_CNPJ,
    nome: "CNPJ",
  },
];

const RESPOSTA_PERGUNTA_SIM = "sim";
const RESPOSTA_PERGUNTA_NAO = "nao";

const optionsRespostaPergunta = [
  {
    id: RESPOSTA_PERGUNTA_SIM,
    nome: "SIM",
  },
  {
    id: RESPOSTA_PERGUNTA_NAO,
    nome: "NÃO",
  },
];

const DialogoCpfNota = forwardRef(
  ({ handleProsseguir = () => {}, cancelar = () => {}, limiteInferiorNotaCpf }, ref) => {
    const [open, setOpen] = useState(false);
    const [cpf, setCpf] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [tipoDocumento, setTipoDocumento] = useState(null);
    const [incluirDocumento, setIncluirDocumento] = useState(null);
    const [tela, setTela] = useState(TELA_INCLUIR_DOCUMENTO);
    const { enqueueSnackbar } = useSnackbar();
    const [dados, setDados] = useState(null);
    const [tipo, setTipo] = useState(0);

    function handleClose() {
      setOpen(false);
    }

    useImperativeHandle(ref, () => ({
      handleOpen(dados, tipo) {
        setCpf("");
        setCnpj("");
        setOpen(true);
        setTela(TELA_INCLUIR_DOCUMENTO);
        setIncluirDocumento(optionsRespostaPergunta[0]);
        setTipoDocumento(optionsTipoDocumento[0]);
        setDados(dados)
        setTipo(tipo)
      },
    }));

    function getDados() {
      let cpfFinal = null;
      let cnpjFinal = null;
      if (incluirDocumento.id === RESPOSTA_PERGUNTA_SIM) {
        if (tipoDocumento.id === TIPO_DOCUMENTO_CPF) {
          cpfFinal = cpf;
          cnpjFinal = null;
        } else {
          cpfFinal = null;
          cnpjFinal = cnpj;
        }
      } else {
        cpfFinal = null;
        cnpjFinal = null;
      }

      return {
        cpf: cpfFinal,
        cnpj: cnpjFinal,
      };
    }

    function handleSalvar() {
      setOpen(false);
      const dados2 = getDados();
      handleProsseguir({
        ...dados2,
      }, dados, tipo);
    }

    function cancelarLocal() {
      setOpen(false)
      cancelar()
    }

    function handleActions(action) {
      switch (action) {
        case FECHAR_VENDA_ACTION: {
          switch (tela) {
            case TELA_INCLUIR_DOCUMENTO:
              if (!erroIncluirDocumento) {
                if (incluirDocumento.id === RESPOSTA_PERGUNTA_SIM) {
                  setTela(TELA_TIPO_DOCUMENTO);
                } else {
                  cancelarLocal()
                }
              }
              break;
            case TELA_TIPO_DOCUMENTO:
              if (!erroTipoDocumento) {
                if (tipoDocumento.id === TIPO_DOCUMENTO_CPF) {
                  setTela(TELA_CPF);
                } else {
                  setTela(TELA_CNPJ);
                }
              }
              break;
            case TELA_CPF:
              if (!erroCpf) {
                handleSalvar();
              }
              break;
            case TELA_CNPJ:
              if (!erroCnpj) {
                handleSalvar();
              }
              break;
            default:
              break;
          }
          break;
        }
        case CANCELAR_VENDA_ACTION: {
          switch (tela) {
            case TELA_INCLUIR_DOCUMENTO:
              setIncluirDocumento(optionsRespostaPergunta[0]);
              setTipoDocumento(optionsTipoDocumento[0]);
              setCpf("");
              setCnpj("");
              cancelarLocal()
              break;
            case TELA_TIPO_DOCUMENTO:
              setTela(TELA_INCLUIR_DOCUMENTO);
              setTipoDocumento(optionsTipoDocumento[0]);
              setCpf("");
              setCnpj("");
              break;
            case TELA_CPF:
              setTela(TELA_TIPO_DOCUMENTO);
              setIncluirDocumento(optionsRespostaPergunta[0]);
              setTipoDocumento(optionsTipoDocumento[0]);
              setCpf("");
              setCnpj("");
              break;
            case TELA_CNPJ:
              setTela(TELA_TIPO_DOCUMENTO);
              setIncluirDocumento(optionsRespostaPergunta[0]);
              setTipoDocumento(optionsTipoDocumento[0]);
              setCpf("");
              setCnpj("");
              break;
            default:
              break;
          }
          break;
        }
        case ESC_ACTION: {
          break;
        }
        default:
          break;
      }
    }

    function handleKey(keyCode, keyName) {
      handleActions(keyName);
    }

    function validateCnpj() {
      let error = "";
      if (cnpj) {
        if (cnpj.length < 14) error = "O CNPJ deve ter 14 dígitos";
        else {
          if (!validarCNPJ(cnpj)) error = "CNPJ Inválido";
        }
      } else {
        error = "Este campo é obrigatório";
      }
      return error;
    }

    const erroCnpj = validateCnpj();

    function validateCpf() {
      let error = "";
      if (cpf) {
        if (cpf.length < 11) error = "O CPF deve ter 11 dígitos";
        else {
          if (!validarCPF(cpf)) error = "CPF Inválido";
        }
      } else {
        error = "Este campo é obrigatório";
      }
      return error;
    }

    const erroCpf = validateCpf();

    function validateTipoDocumento() {
      let error = "";
      if (!tipoDocumento) {
        error = "Este campo é obrigatório";
      }
      return error;
    }

    const erroTipoDocumento = validateTipoDocumento();

    function validateIncluirDocumento() {
      let error = "";
      if (!incluirDocumento) {
        error = "Este campo é obrigatório";
      }
      return error;
    }

    const erroIncluirDocumento = validateIncluirDocumento();


    let componente = null;

    switch (tela) {
      case TELA_INCLUIR_DOCUMENTO:
        componente = (
          <TelaOpcao
            value={incluirDocumento}
            onChange={(value) => setIncluirDocumento(value)}
            erro={erroIncluirDocumento}
            options={optionsRespostaPergunta}
            handleEnter={() => {
              handleActions(FECHAR_VENDA_ACTION);
            }}
            handleKey={handleKey}
            label={"Deseja declarar CPF ou CNPJ na NFCe?"}
          />
        );
        break;
      case TELA_TIPO_DOCUMENTO:
        componente = (
          <TelaOpcao
            value={tipoDocumento}
            onChange={(value) => setTipoDocumento(value)}
            erro={erroTipoDocumento}
            options={optionsTipoDocumento}
            handleEnter={() => {
              handleActions(FECHAR_VENDA_ACTION);
            }}
            handleKey={handleKey}
            label={"Qual o tipo de Documento"}
          />
        );
        break;
      case TELA_CPF:
        componente = (
          <TelaCpf
            value={cpf}
            onChange={(value) => setCpf(value)}
            erro={erroCpf}
            handleEnter={() => {
              handleActions(FECHAR_VENDA_ACTION);
            }}
            handleKey={handleKey}
          />
        );
        break;
      case TELA_CNPJ:
        componente = (
          <TelaCnpj
            value={cnpj}
            onChange={(value) => setCnpj(value)}
            erro={erroCnpj}
            handleEnter={() => {
              handleActions(FECHAR_VENDA_ACTION);
            }}
            handleKey={handleKey}
          />
        );
        break;
      default:
        break;
    }

    function getTitle() {
      switch (tela) {
        case TELA_INCLUIR_DOCUMENTO:
          return `Sua compra passou do limite de ${formatMoeda(limiteInferiorNotaCpf)} para adicionar este item, é preciso informar o CPF OU CNPJ, deseja informar?`;
        case TELA_TIPO_DOCUMENTO:
          return "Qual o tipo de Documento";
        case TELA_CPF:
          return "Me diga o seu CPF";
        case TELA_CNPJ:
          return "Me diga o seu CNPJ";
        default:
          return "";
      }
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
          disableEscapeKeyDown
          fullWidth
          maxWidth={"xs"}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              color: "white",
              backgroundColor: SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {getTitle()}
          </DialogTitle>
          <DialogContent
            style={{
              padding: "20px 10px",
            }}
          >
            {componente}
          </DialogContent>
          <DialogActions
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`VOLTAR (${CANCELAR_VENDA_ACTION})`}
            </Button>
            <Button
              onClick={() => handleActions(FECHAR_VENDA_ACTION)}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`AVANÇAR (${FECHAR_VENDA_ACTION})`}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default DialogoCpfNota;
